import { Eye, Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription, AlertTitle } from '@nucleus-commerce/ui/components/alert';
import { cn } from '@nucleus-commerce/ui/lib/utils';

import type { ReadOnlyReason } from './use-store-editable';

export interface ReadOnlyBannerProps {
  reason: ReadOnlyReason | null;
  className?: string;
}

/** Says why a settings screen cannot be changed; renders nothing when it can. */
export function ReadOnlyBanner({ reason, className }: ReadOnlyBannerProps) {
  const { t } = useTranslation('common');
  if (!reason) return null;
  const Icon = reason === 'closed' ? Lock : Eye;
  return (
    <Alert
      role="status"
      className={cn('mb-4', className)}
      data-testid={`read-only-${reason}`}
      data-tour="settings.read-only"
    >
      <Icon aria-hidden />
      <AlertTitle>{t(`readOnly.${reason}.title`)}</AlertTitle>
      <AlertDescription>{t(`readOnly.${reason}.description`)}</AlertDescription>
    </Alert>
  );
}
